import { useEffect, useState } from 'react'
import { Link, NavLink, useLocation } from 'react-router-dom'
import { Phone, Menu, X } from 'lucide-react'
import { PHONE_DISPLAY, PHONE_TEL } from '../lib/constants'

const NAV_LINKS = [
  { to: '/', label: 'Home', end: true },
  { to: '/services', label: 'Services' },
  { to: '/client-directed-home-care-invoicing', label: 'CDHCI' },
  { to: '/how-it-works', label: 'How It Works' },
  { to: '/family-room', label: 'Family Room' },
  { to: '/resources', label: 'Resources' },
  { to: '/about', label: 'About' },
  { to: '/careers', label: 'Careers' },
  { to: '/contact', label: 'Contact' },
]

export default function Header() {
  const [open, setOpen] = useState(false)
  const { pathname } = useLocation()

  useEffect(() => {
    setOpen(false)
  }, [pathname])

  return (
    <div>
      <div style={{ background: 'var(--color-teal-900)', color: 'var(--color-cream)', fontSize: 15 }}>
        <div className="container-site topbar">
          <p style={{ margin: 0 }}>🍁 Proudly Canadian owned and operated · Calgary, AB</p>
          <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
            <Link
              to="/login"
              style={{ color: 'var(--color-cream)', fontWeight: 600, textDecoration: 'underline', textUnderlineOffset: 4 }}
            >
              Portal Login
            </Link>
            <a
              href={PHONE_TEL}
              style={{
                color: 'var(--color-cream)',
                fontWeight: 600,
                textDecoration: 'none',
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                whiteSpace: 'nowrap',
              }}
            >
              <Phone size={16} />
              Call {PHONE_DISPLAY}
            </a>
          </div>
        </div>
      </div>

      <header
        style={{
          position: 'sticky',
          top: 0,
          zIndex: 50,
          borderBottom: '1px solid var(--color-line)',
          background: 'oklch(0.9765 0.0098 87.47 / 95%)',
          backdropFilter: 'blur(8px)',
        }}
      >
        <div className="container-site nav-bar">
          <Link to="/" style={{ display: 'inline-flex', alignItems: 'center', flexShrink: 0 }}>
            <img src="/assets/logo.png" alt="True North Care and Support" className="nav-logo" />
          </Link>

          <button
            type="button"
            className="nav-toggle"
            aria-expanded={open}
            aria-controls="primary-nav"
            aria-label={open ? 'Close menu' : 'Open menu'}
            onClick={() => setOpen((v) => !v)}
          >
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>

          <nav id="primary-nav" aria-label="Main" className={open ? 'nav-links nav-links-open' : 'nav-links'}>
            {NAV_LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.end}
                style={({ isActive }) => ({
                  padding: '8px 0',
                  fontSize: 17,
                  color: isActive ? 'var(--color-teal-800)' : 'var(--color-ink)',
                  fontWeight: isActive ? 600 : 400,
                  textDecoration: 'none',
                })}
              >
                {l.label}
              </NavLink>
            ))}
            <Link to="/schedule-assessment" className="btn btn-primary nav-cta">
              Schedule an Assessment
            </Link>
          </nav>
        </div>
      </header>
    </div>
  )
}
